import React, { useState, useEffect } from 'react';
import { HomefieldIconOrderCartOutline } from '@dsg-tech/homefield-react-icons';
import { getCookie } from 'utility/cookie-utils';
import { checkStores } from 'utility/utility';
import './Cart.scss';

const CartCount = () => {
  const [cartCount, setCartCount] = useState<number | string>(0);

  useEffect(() => {
    const dsgCartQtyCookie = getCookie('DSG_CartQTY');
    const cartCountCookie = getCookie('cartCount');
    if (dsgCartQtyCookie && !Number.isNaN(dsgCartQtyCookie)) {
      setCartCount(parseInt(dsgCartQtyCookie, 10));
    }
    if (cartCountCookie && !Number.isNaN(cartCountCookie)) {
      setCartCount(parseInt(cartCountCookie, 10));
    }

    // async updates from external apps
    window.cartCountComponent = {
      setCartCount,
    };
  });

  return (
    <a
      className="cart-container-header hmf-display-flex hmf-justify-content-center hmf-p-md-xxs hmf-soft-radius hmf-text-align-center hmf-text-decoration-none"
      data-em="Header_ShoppingCart"
      title="Cart"
      href={checkStores(`/OrderItemDisplay`)}
      aria-label={`Cart ${cartCount} ${cartCount === 1 ? 'item' : 'items'}`}>
      <div className="cart-link-content hmf-position-relative hmf-display-flex hmf-flex-column hmf-flex-md-row hmf-align-items-center">
        <HomefieldIconOrderCartOutline className="cart-icon" height="24px" width="24px" />

        {Number(cartCount) > 0 && (
          <span
            id="OrderQty"
            className={`cart-item-count hmf-position-absolute hmf-legal-s hmf-text-align-center hmf-round-radius ${
              cartCount > 99 ? 'cart-item-count--large' : ''
            }`}>
            {cartCount > 99 ? '99+' : cartCount}
          </span>
        )}

        <span
          aria-label={cartCount < 2 ? 'item in cart' : 'items in cart'}
          className="hmf-body-bold-l hmf-display-none hmf-display-md-inline hmf-pr-xxxs hmf-pl-xxs">
          Cart
        </span>
      </div>
    </a>
  );
};

export default CartCount;
